/** Pure map-marker helpers — deliberately free of leaflet imports so the
 *  filtering logic unit-tests without a map runtime. */

import type { DispatchLocation, DispatchTarget } from '../../types/oms.ts'

export interface SourceMarker {
  outageId: number
  position: [number, number]
  target: DispatchTarget
  location: DispatchLocation | null
}

const TARGETS: ReadonlySet<string> = new Set(['confirmed_device', 'suggested_device', 'event_device'])

/** Collect source markers (spec 2026-09-01 §C) from outage map features —
 *  TOP-LEVEL events only, keyed on the server's `has_live_parent` (parent
 *  exists AND is active/restored), NOT the literal parent link: an event
 *  promoted from under a closed parent keeps its marker, matching the
 *  roots_only list. Child events under a LIVE parent often carry their own
 *  (dedicated-fuse) suggestions; during the 2026-07-21 d911 outage that
 *  painted 29 noise diamonds around the one that mattered. */
export function collectSourceMarkers(
  features: Array<{ properties?: Record<string, unknown> | null }>,
): SourceMarker[] {
  const out: SourceMarker[] = []
  for (const f of features) {
    const p = f.properties ?? {}
    const target = p.dispatch_target
    if (
      p.has_live_parent !== true &&
      typeof p.dispatch_lat === 'number' &&
      typeof p.dispatch_lon === 'number' &&
      typeof target === 'string' &&
      TARGETS.has(target)
    ) {
      out.push({
        outageId: p.id as number,
        position: [p.dispatch_lat, p.dispatch_lon],
        target: target as DispatchTarget,
        location: (p.dispatch_location as DispatchLocation | null | undefined) ?? null,
      })
    }
  }
  return out
}
